export default __webpack_public_path__ + "img/6cbc623d9931aa5da04a3b2d61fae46f.svg";